import { useState, useEffect } from "react";
import { apiRequest } from "../../network/apiClient";
import {API_ENDPOINTS} from "../apiEndpoints";

export const useGetLeadDetailsSquare = ({leadId}) => {
    const [leadDetails, setLeadDetails] = useState(null)

    const fetchLeadDetails = async () => {
        try {
            const queryParams = new URLSearchParams({
                lead_id: leadId,
            })
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.GET_LEADS.CARD}?${queryParams.toString()}`, 'GET');
            setLeadDetails(result);
        } catch (error) {
            console.error('Error fetching details:', error);
        }
    }

    useEffect(() => {
        if (!leadId) return;
        fetchLeadDetails();
    }, [leadId]);

    return {leadDetails, refetch: fetchLeadDetails};
}
